module.exports = __webpack_public_path__ + "685f45b727cc779e3b9b6b99105306ea.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/path2.svg
// module id = 675
// module chunks = 0